import PropTypes from 'prop-types';
import colorsPropTypes from '../utils/colors';
var propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  color: PropTypes.oneOfType([PropTypes.oneOf(colorsPropTypes), PropTypes.string]),
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  flippable: PropTypes.bool,
  focusable: PropTypes.bool,
  quietArea: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  src: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string
};
export default propTypes;